/// <reference path="../../app.definition.ts" />

import { CachedItem } from "./_cachedItem";
import { User } from "./user";

export class CachedUser extends CachedItem {
    id: number;
    firstName: string;
    lastName: string;
    providerIdentity: string;
    photo: string;
    bgColor: string;
    permissionType: string;
    isFormerTeamMember: boolean;
    permissionEndDate: string;
    organizationId;
    organizationName;
    organizationShortName;

    deserialize(input: User): CachedUser {
        (!!input.id || !!input.userId) && (this.id = (input.id || input.userId));
        !!input.firstName && (this.firstName = input.firstName);
        !!input.lastName && (this.lastName = input.lastName);
        !!input.providerIdentity && (this.providerIdentity = input.providerIdentity);
        !!input.photo && (this.photo = input.photo);
        !!input.bgColor && (this.bgColor = input.bgColor);
        (input.organizationId) && (this.organizationId = input.organizationId);
        !!input.organizationName && (this.organizationName = input.organizationName);
        !!input.organizationShortName && (this.organizationShortName = input.organizationShortName);

        super.deserialize(input);
        return this;
    }

    constructor() {
        super();
    }

    public static from(item: any) {
        return new CachedUser().deserialize(item);
    }
}
